export const loginStyles = (theme) => {
  return {
    root: {
      minHeight: '100vh',
      display: 'flex',
    },
    leftWrapper: {
      backgroundColor: '#FFFFFF',
      flex: 1,
      [theme.breakpoints.down('sm')]: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url("images/auth_bg.jpg")',
      },
      [theme.breakpoints.down('xs')]: {
        backgroundImage: 'none',
        backgroundColor: '#f3f3f3',
      },
    },
    displaySM: {
      display: 'block',
      width: '50%',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    rightWrapper: {
      height: '100%',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: 'url("images/auth_bg.jpg")',
    },
    container: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    panel: {
      margin: '20px 0',
      padding: '30px 60px',
      borderRadius: 4,
      backgroundColor: '#FFFFFF',
      [theme.breakpoints.down('xs')]: {
        padding: '20px',
      },
    },
    signupWrapper: {
      textAlign: 'center',
    },
    signupLink: {
      textDecoration: 'none',
      margin: '0 4px',
    },
    signupMessage: {
      color: theme.palette.primary.main,
      fontFamily: 'FSEmeric-Medium',
      textDecoration: 'underline',
    },
  }
}
